
import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "78px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 40px",
        boxSizing: "border-box",
        backgroundColor: "#3B4CCA",
        borderBottom: "4px solid #FFCB05",
        zIndex: 1000,
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.25)",
      }}
    >
      {/* LOGO + NOM DE L'APPLICATION */}
      <Link
        to="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          textDecoration: "none",
          height: "100%",
        }}
      >
       

        {/* NOM DE L'APPLICATION */}
        <span
          style={{
            color: "#FFFFFF",
            fontSize: "1.5rem",
            fontWeight: "700",
            letterSpacing: "0.5px",
            whiteSpace: "nowrap",
          }}
        >
          Poké<span style={{ color: "#FFCB05" }}>Warm</span>
        </span>
      </Link>
    </header>
  );
};

export default Header;

